import { Shield, CheckCircle, Lock, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

const TrustSignals = () => {
  const { t } = useTranslation('misc');

  const signals = [
    {
      icon: Shield,
      text: t('trustSignals.guarantee.title'),
      subtext: t('trustSignals.guarantee.subtitle')
    },
    {
      icon: CheckCircle,
      text: t('trustSignals.consultation.title'),
      subtext: t('trustSignals.consultation.subtitle')
    },
    {
      icon: Lock,
      text: t('trustSignals.security.title'),
      subtext: t('trustSignals.security.subtitle')
    },
    {
      icon: Star,
      text: t('trustSignals.experience.title'),
      subtext: t('trustSignals.experience.subtitle')
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-8">
      {signals.map((signal, index) => (
        <div 
          key={index}
          className="text-center p-4 rounded-lg bg-background/80 border border-border/50 hover:bg-muted/50 transition-smooth"
        >
          <signal.icon className="w-6 h-6 text-accent mx-auto mb-2" />
          <div className="text-sm font-semibold text-foreground">{signal.text}</div>
          <div className="text-xs text-muted-foreground mt-1">{signal.subtext}</div>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;